// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react';
import { ArrowLeft, ArrowUpRight, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useI18n } from '../i18n/I18nContext.jsx';
import { VisualIcon } from './VisualIcon.jsx';

export const navigatorCopy = {
  ru: {
    triggerKicker: 'Инженерный навигатор', trigger: 'Есть задача?', code: 'ANLEXX / PROJECT ROUTER',
    title: 'С чего начать?', lead: 'Выберите ситуацию — покажем маршрут и исходные данные для первого разговора.',
    destination: 'Маршрут', prepare: 'Подготовьте, если есть', back: 'Изменить задачу', go: 'Подготовить обращение',
    note: 'Навигатор ничего не отправляет. Контактные данные вводятся только на странице обращения.', close: 'Закрыть инженерный навигатор',
    tasks: {
      engineering: ['Новый участок или модернизация', 'Нужны проектирование, интеграция и запуск.', 'Инженерный центр', 'design', ['Описание задачи', 'Схема или фото линии', 'Продукт и упаковка']],
      equipment: ['Подобрать оборудование', 'Нужно сравнить технологии и конфигурации.', 'Инженерный подбор', 'settings', ['Скорость линии', 'Размер продукта', 'Требуемая операция']],
      service: ['Линия работает нестабильно', 'Нужны диагностика, настройка или ремонт.', 'Сервисная служба', 'service', ['Модель оборудования', 'Фото ошибки', 'Описание симптома']],
      consumables: ['Расходные материалы и запасные части', 'Нужно подобрать совместимые расходники или детали.', 'Снабжение и сервис', 'packaging', ['Модель оборудования', 'Нужная позиция или описание', 'Количество']],
      tracora: ['Связать коды и данные', 'Нужны сериализация, агрегация или обмен данными.', 'Команда Tracora', 'software', ['Уровни упаковки', 'Источник кодов', 'Схема движения продукции']],
      audit: ['Разобраться в процессе', 'Сначала нужен аудит участка и ограничений.', 'Предпроектный аудит', 'audit', ['Текущая операция', 'Проблемы участка', 'Ожидаемый результат']],
    },
  },
  uz: {
    triggerKicker: 'Muhandislik navigatori', trigger: 'Vazifa bormi?', code: 'ANLEXX / PROJECT ROUTER',
    title: 'Nimadan boshlash kerak?', lead: 'Vaziyatni tanlang — birinchi suhbat uchun yo‘nalish va boshlang‘ich ma’lumotlarni ko‘rsatamiz.',
    destination: 'Yo‘nalish', prepare: 'Mavjud bo‘lsa, tayyorlang', back: 'Vazifani o‘zgartirish', go: 'Murojaatni tayyorlash',
    note: 'Navigator hech narsa yubormaydi. Kontakt ma’lumotlari faqat murojaat sahifasida kiritiladi.', close: 'Muhandislik navigatorini yopish',
    tasks: {
      engineering: ['Yangi uchastka yoki modernizatsiya', 'Loyihalash, integratsiya va ishga tushirish kerak.', 'Muhandislik markazi', 'design', ['Vazifa tavsifi', 'Liniya sxemasi yoki fotosi', 'Mahsulot va qadoq']],
      equipment: ['Uskunani tanlash', 'Texnologiya va konfiguratsiyalarni solishtirish kerak.', 'Muhandislik tanlovi', 'settings', ['Liniya tezligi', 'Mahsulot o‘lchami', 'Kerakli operatsiya']],
      service: ['Liniya beqaror ishlamoqda', 'Diagnostika, sozlash yoki ta’mir kerak.', 'Servis xizmati', 'service', ['Uskuna modeli', 'Xato fotosi', 'Muammo tavsifi']],
      consumables: ['Sarf materiallari va ehtiyot qismlar', 'Mos sarf materiallari yoki ehtiyot qismlarni tanlash kerak.', 'Ta’minot va servis', 'packaging', ['Uskuna modeli', 'Kerakli pozitsiya yoki tavsif', 'Miqdori']],
      tracora: ['Kodlar va ma’lumotlarni bog‘lash', 'Serializatsiya, agregatsiya yoki ma’lumot almashinuvi kerak.', 'Tracora jamoasi', 'software', ['Qadoq darajalari', 'Kodlar manbasi', 'Mahsulot harakati sxemasi']],
      audit: ['Jarayonni tahlil qilish', 'Avval uchastka va cheklovlar auditi kerak.', 'Loyihaoldi auditi', 'audit', ['Joriy operatsiya', 'Uchastka muammolari', 'Kutilgan natija']],
    },
  },
  en: {
    triggerKicker: 'Engineering navigator', trigger: 'Have a task?', code: 'ANLEXX / PROJECT ROUTER',
    title: 'Where should we start?', lead: 'Choose the situation and we will show the route and useful inputs for the first discussion.',
    destination: 'Route', prepare: 'Prepare, if available', back: 'Change the task', go: 'Prepare the request',
    note: 'The navigator sends nothing. Contact details are entered only on the request page.', close: 'Close engineering navigator',
    tasks: {
      engineering: ['New area or modernization', 'Design, integration and commissioning are required.', 'Engineering center', 'design', ['Task description', 'Line layout or photo', 'Product and packaging']],
      equipment: ['Select equipment', 'Compare technologies and configurations.', 'Engineering selection', 'settings', ['Line speed', 'Product dimensions', 'Required operation']],
      service: ['The line is unstable', 'Diagnostics, adjustment or repair are required.', 'Service team', 'service', ['Equipment model', 'Error photo', 'Symptom description']],
      consumables: ['Consumables and spare parts', 'Select compatible consumables or replacement parts.', 'Supply and service', 'packaging', ['Equipment model', 'Required item or description', 'Quantity']],
      tracora: ['Connect codes and data', 'Serialization, aggregation or data exchange are required.', 'Tracora team', 'software', ['Packaging levels', 'Code source', 'Product-flow scheme']],
      audit: ['Understand the process', 'Start with an audit of the area and constraints.', 'Pre-project audit', 'audit', ['Current operation', 'Area constraints', 'Expected result']],
    },
  },
};

export function ProjectNavigator() {
  const { locale } = useI18n();
  const location = useLocation();
  const copy = navigatorCopy[locale] || navigatorCopy.ru;
  const [open, setOpen] = useState(false);
  const [selectedKey, setSelectedKey] = useState(null);
  const triggerRef = useRef(null);
  const panelRef = useRef(null);

  useEffect(() => {
    const frame = requestAnimationFrame(() => setOpen(false));
    return () => cancelAnimationFrame(frame);
  }, [location.pathname, location.search]);
  useEffect(() => {
    if (!open) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    panelRef.current?.focus();
    const onKeyDown = event => { if (event.key === 'Escape') closeNavigator(); };
    document.addEventListener('keydown', onKeyDown);
    return () => { document.body.style.overflow = previousOverflow; document.removeEventListener('keydown', onKeyDown); };
  }, [open]);

  function closeNavigator() {
    setOpen(false);
    requestAnimationFrame(() => triggerRef.current?.focus());
  }

  if (location.pathname === '/contacts') return null;
  const selected = selectedKey ? copy.tasks[selectedKey] : null;

  return <>
    <button ref={triggerRef} type="button" className="project-navigator-trigger" onClick={() => setOpen(true)} aria-expanded={open} aria-controls="project-navigator-panel">
      <span className="project-navigator-signal" aria-hidden="true"/>
      <span><small>{copy.triggerKicker}</small><strong>{copy.trigger}</strong></span>
      <ArrowUpRight aria-hidden="true"/>
    </button>
    {open && <div className="project-navigator-backdrop" onMouseDown={event => { if (event.target === event.currentTarget) closeNavigator(); }}>
      <aside ref={panelRef} tabIndex={-1} className="project-navigator-panel" id="project-navigator-panel" role="dialog" aria-modal="true" aria-labelledby="project-navigator-title">
        <header><span>{copy.code}</span><button type="button" onClick={closeNavigator} aria-label={copy.close}><X aria-hidden="true"/></button></header>
        <div className="project-navigator-body">
          <div className="project-navigator-intro"><span>01 / ROUTE</span><h2 id="project-navigator-title">{copy.title}</h2><p>{copy.lead}</p></div>
          {!selected && <div className="project-navigator-tasks">{Object.entries(copy.tasks).map(([key, task]) => <button type="button" key={key} onClick={() => setSelectedKey(key)}>
            <VisualIcon name={task[3]}/><span><strong>{task[0]}</strong><small>{task[1]}</small></span><ArrowUpRight aria-hidden="true"/>
          </button>)}</div>}
          {selected && <div className="project-navigator-result">
            <button type="button" className="project-navigator-back" onClick={() => setSelectedKey(null)}><ArrowLeft aria-hidden="true"/> {copy.back}</button>
            <div className="project-navigator-route"><VisualIcon name={selected[3]}/><span><small>{copy.destination}</small><strong>{selected[2]}</strong></span></div>
            <h3>{selected[0]}</h3><p>{selected[1]}</p>
            <h4>{copy.prepare}</h4><ol>{selected[4].map(item => <li key={item}>{item}</li>)}</ol>
            <Link className="button primary" to={`/contacts?type=${selectedKey}`}>{copy.go}<ArrowUpRight aria-hidden="true"/></Link>
          </div>}
        </div>
        <footer>{copy.note}</footer>
      </aside>
    </div>}
  </>;
}
